module.exports = __webpack_public_path__ + "img/saleimg2.38c9047a.png";